__webpack_require__.p = "https://v2-product.apps.qorcommerce.io/";